import { Component, OnInit } from '@angular/core';
import { TicketsService, PartsService, BatchService, FavoriteService,MessageService, ManufacturerService, UserService } from 'src/app/services'
import { CreateTicketFormFields, addUnlistedPart, buildingUsedRepair } from 'src/app/models/tickets/createTicketFormFields'
import { SelectItem } from 'primeng/api/selectitem';
import { BartTicketValidate } from 'src/app/models/tickets/bart.ticket.validate'
import { ConfirmationService } from 'primeng/api';
import { CurrencyPipe} from '@angular/common';
import { Table } from "primeng/table";
import { ViewChild } from '@angular/core';
import { AccessUserInfo, UserDetail } from 'src/app/models';


@Component({
  selector: 'bart-parts-used',
  templateUrl: './parts-used.component.html',
  styleUrls: ['./parts-used.component.scss']
})
export class PartsUsedComponent implements OnInit {
  @ViewChild("dtpartUsed", { static: false }) public dt: Table
  public formFields: CreateTicketFormFields;
  public addPart: addUnlistedPart;
  public TotalAmount: number = 0;
  public TotalAmountUSD:string="0";
  partUsedColumns: any[];
  public userId: number;
  partsUsedTableColumns: any[];
  partSource: any;
  public todayDate: Date= new Date();
  enableVendorButtons: boolean = false;
  favoritelistColumn: any[];
  partList: any[];
  selectedpartList:any;
  VendorList: any;
  favoritePartsArray: any;
  selectedfavoriteParts: any;
  favoritePartsArrayTemp: any;
  selectedRowData: buildingUsedRepair[] = [];
  FavoriteDropdown: SelectItem[];
  addToFavoriteDropdown: SelectItem[]=[];
  searchText: string = "";
  showAddPartDailog: boolean = false;
  showFavouriteListDailog: boolean = false;
  public manufacturerId: number;
  public SelectedFavouriteID: SelectItem;
  public IsSaved: boolean = false;
  public ShowaddfavouriteDailoge: boolean = false;
  public isunique:boolean=false;
  public favoriteListName:string="";
  public favoriteListTypeId: number =1;
  saveVendor = {
    manufacturerId: null,
    partNumber: null,
    partDescription: null,
    unitPrice: null,
    adHocValid: true
  }
  validateAdHocPartParam = {
    PartNumber: null,
  }
  addFavouritelistparam = {
    favoriteListId: null,
    partId: null,
    description: null,
    favoritenmae: null,
    partNumber: null,
  }

  createPartAdhocParam = {
    manufacturerId: null,
    partNumber: null,
    partDescription: null,
    unitPrice: null,
    UserID: 1
  }
  addManufacturerParam = {
    "CHECKMANUFACTURER": {
      manufacturerID: 0,
      manufacturerName: null

    },
    "ADDMANUFACTURER":
    {
      manufacturerName: null,
      isActiveFlag: 1,
      UserID: null,
      iProcVendorId: null,
      warrantyDefaultEquipment: null,
      warrantyDefaultParts: null
    }
  }

  Parameters = {
    isActiveFlag: "1"
  }
  params = {
    favoriteListTypeId: 1,
    activePart: 1,
    sortColumn: "favoriteListName ASC, partDescription ASC",
    userId: null
  }
  BachParam = {
    BatchId: 0
  }
  ModelPartParams = {
    "GETMODELPARTS":
    {
      modelId: null,
      searchTerm: null,
      sortColumn: null
    }
  }
  public isPaginatorVisible:boolean=false;
  constructor(private _ticketsService: TicketsService,
    private _partsService: PartsService,
    private _batchService: BatchService,
    private _favoriteService: FavoriteService,
    private _manufacturerService: ManufacturerService,
    private _userService: UserService,
    private _bartTicketValidate: BartTicketValidate,
    private _confirmationService: ConfirmationService,
    private _messageService:MessageService,
    private currencyPipe : CurrencyPipe) {
    this.addPart = new addUnlistedPart();
  }
  ngOnInit() {
    let userInfo:UserDetail = AccessUserInfo.getUserInfo();
    this.userId = userInfo.userId;
    this._ticketsService.getTicketGlobalData().subscribe((Result: any) => {
      this.formFields = Result;
   
    },
      (respose: Response) => {
        // handle error here
      }
    );
    this.partUsedColumns = [
      { field: 'partNumber', header: 'Part#' },
      { field: 'partDescription', header: 'Description' },
      { field: 'unitCost', header: 'Price' },
      { field: 'partOriginValue', header: 'Part Info.' },
      { field: 'manufacturerName', header: 'Vendor' },
      { field: 'mfgPartNumber', header: 'Mfg.Part#' },
      { field: 'bestValue', header: 'Best Value' },
    ];


    this.partsUsedTableColumns = [
      { field: 'partId', header: 'Part #' },
      { field: 'rgaNumber', header: 'RGA #' },
      { field: 'manufacturerName', header: 'Vendor' },
      { field: 'partNumber', header: 'Part Name' },
      { field: 'dateOfInstall', header: 'Date Installed' },
      { field: 'zeroCost', header: '$0 Cost?' },
      { field: 'unitCost', header: 'Price' },
      { field: 'Quantity', header: 'Quantity' },

    ];

    this.favoritelistColumn = [
      { field: 'partNumber', header: 'Part Number' },
      { field: 'partDescription', header: 'Part Description'},
      { field: 'unitCost', header: 'Unit Cost' },
      { field: 'manufacturerName', header: 'Manufacturer' },
      { field: 'mfgPartNumber', header: 'Mfg Part Number' },

    ];
    this.getFavoriteListParts();
    this.buildTicketPartSource();
    this.getManufacturer();
  }
  public SearchButtonclick() {
    this.partList=[];
    this.selectedpartList=[];
    this.selectedfavoriteParts=[];
    this.ModelPartParams.GETMODELPARTS.modelId = this.formFields.selectedEquipmentList["ModelID"];
    this.ModelPartParams.GETMODELPARTS.searchTerm = this.searchText;
    this._partsService.getModelParts(JSON.stringify(this.ModelPartParams)).subscribe((Result: any) => {
      if (Result.parts.length > 0) {        
        this.partList = Result.parts;
        this.isPaginatorVisible=true;
      }
      else{
        this.partList = Result.parts;
        this.isPaginatorVisible=false;
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
this.dt.reset();
  }
  public AddUnlistedPart() {
    this.showAddPartDailog = true;
    
  }
  public getManufacturer() {
    var GETMANUFACTURERS = this.Parameters;
    this._manufacturerService.getManufacturers(JSON.stringify({ GETMANUFACTURERS })).subscribe((Result: any) => {
      if (Result.manufacturers.length > 0)
        this.VendorList = [];
      for (let c of Result.manufacturers) {
        this.VendorList.push({ label: c.ManufacturerName, value: c.ManufacturerID });;
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
  }
  public getFavoriteListParts() {
    this.getFavoriteList();
    this.params.userId = this.userId;
    var GETFAVORITELISTPARTS = this.params;
    this._favoriteService.getFavoriteListParts(JSON.stringify({ GETFAVORITELISTPARTS })).subscribe((Result: any) => {
      if (Result != undefined && Result != "" && Result != null) {
        this.favoritePartsArray=[];
        this.selectedfavoriteParts=[];
        let favListName = "";
        this.favoritePartsArray = Result.records;
        this.favoritePartsArrayTemp = Result.records;
        this.FavoriteDropdown = [];
        this.FavoriteDropdown.push({ label: "--ALL LIST--", value: 0 }); //Commented By Harikesh on 12-Oct-2020 for Defect#12234
        for (let c of Result.records) {
          if(this.FavoriteDropdown.filter(x=>x.value==c.favoriteListId).length==0)
          {
           this.FavoriteDropdown.push({ label: c.favoriteListName, value: c.favoriteListId });
          }
        }
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );

  }
  public getFavoriteParts() {
    this.showFavouriteListDailog = true;
    this.getFavoriteListParts();

  }
  public addVendorClick() {
    this.enableVendorButtons = true;
  }
  public Cancel() {
    this.enableVendorButtons = false;
    this.addPart.manufacturerName=null;
  }
  public addManufacturer() {
    this.addManufacturerParam.ADDMANUFACTURER.UserID = this.userId;
    this.addManufacturerParam.CHECKMANUFACTURER.manufacturerName = this.addPart.manufacturerName;
    this.addManufacturerParam.ADDMANUFACTURER.manufacturerName = this.addPart.manufacturerName
    this._manufacturerService.addManufacturer(JSON.stringify(this.addManufacturerParam)).subscribe((Result: any) => {
      if (Result.alreadyexists > 0) {      
        this._messageService.showAlertMessage("Manufacturer already exists.")
      }
      else {
        this.getManufacturer()
        this.addPart.manufacturerName=null
      }

    },
      (respose: Response) => {
        // handle error here
      }

    );
    this.enableVendorButtons = false;
  }
  public vendoronchage(value) {
    this.manufacturerId = value
  }
  async savePart() {
    this.showAddPartDailog = false;
    var errors=new Array();
    //validate
    this.validateAdHocPartParam.PartNumber = this.addPart.partNumber
    var ISPARTUNIQUE = this.validateAdHocPartParam;
    //Create
    this.createPartAdhocParam.manufacturerId = this.manufacturerId;
    this.createPartAdhocParam.partDescription = this.addPart.partDescription;
    this.createPartAdhocParam.partNumber = this.addPart.partNumber;
    this.createPartAdhocParam.unitPrice = this.addPart.unitPrice;
    this.createPartAdhocParam.UserID = this.userId;
    var CREATEADHOCPART = this.createPartAdhocParam;

    var adHocValid = this.validateAdHocPart(this.createPartAdhocParam);
    if (adHocValid != null && adHocValid != undefined) {
      if (adHocValid.isValid) {
        let Data: buildingUsedRepair;
        if (adHocValid.partUnique) {

          this._partsService.createAdHocPart(JSON.stringify({ CREATEADHOCPART })).subscribe((Result: any) => {
            if (Result.partInfo.length > 0) {
              if (this.formFields.partsUsedDuringRepair == null) {
                this.formFields.partsUsedDuringRepair = [];
              }
              Data = {
                quantity: 1,
                partId: Result.partInfo[0].partId,
                partNumber: Result.partInfo[0].partNumber,
                manufacturerName: Result.partInfo[0].manufacturerName,
                partDescription: Result.partInfo[0].partDescription,
                originalUnitCost: Result.partInfo[0].unitPrice,
                unitCost: Result.partInfo[0].unitPrice,
                dateOfInstall: this.formFields.srCompletedDate,// new Date().toLocaleDateString(),
                isPartUnderWarranty: -1,
                rgaNumber: '',
                showRgaOptions: -1,
                ticketPartSourceId: null,
                isReplacingWarrantyPartFlag: false,
                isRGAQualifiedFlag: false,
                zeroCost: false
              }
              this.formFields.partsUsedDuringRepair.push(Data);
              this.formFields.partsUsedDuringRepair= this.formFields.partsUsedDuringRepair.filter(
                (thing, i, arr) => arr.findIndex(t => t.partId=== thing.partId) === i
              );
              this.gettotalAmount();
            }
            //adHocPartExists
            else {
              if (this.formFields.partsUsedDuringRepair == null) {
                this.formFields.partsUsedDuringRepair = [];
              }
              Data = {
                quantity: 1,
                partId: Result.partInfo[0].partId,
                partNumber: Result.partInfo[0].partNumber,
                manufacturerName: Result.partInfo[0].manufacturerName,
                partDescription: Result.partInfo[0].partDescription,
                originalUnitCost: Result.partInfo[0].unitPrice,
                unitCost: Result.partInfo[0].unitPrice,
                dateOfInstall: this.formFields.srCompletedDate,//new Date().toLocaleDateString(),//Added By Harikesh on 23-July2020 brian Testing Issue
                isPartUnderWarranty: -1,
                rgaNumber: '',
                showRgaOptions: -1,
                ticketPartSourceId: null,
                isReplacingWarrantyPartFlag: false,
                isRGAQualifiedFlag: false,
                zeroCost: false
              }
              this.formFields.partsUsedDuringRepair.push(Data);
              this.formFields.partsUsedDuringRepair= this.formFields.partsUsedDuringRepair.filter(
                (thing, i, arr) => arr.findIndex(t => t.partId=== thing.partId) === i
              );
              this.gettotalAmount();
            }
          },
            (respose: Response) => {
              // handle error here
            }
          );
        }
        else {

        }
        this.showAddPartDailog = false;
        this.addPart.manufacturerId=0;
        this.addPart.partDescription=null;
        this.addPart.partNumber=null;
        this.addPart.unitPrice=null;
      }
      else {
        var errorText = "";
        for (let i = 0; i < adHocValid.Mesg.length; i++) {
          errorText += adHocValid.Mesg[i] + '\n';
        }
        this._messageService.showAlertMessage(errorText);
        this.showAddPartDailog = true;
      }
    }
    (respose: Response) => {
      // handle error here
    }
    // );

  }
  public buildTicketPartSource() {
    var GETTICKETPARTS = {
      partId: null
    };
    this._ticketsService.getTicketPartSource(JSON.stringify({ GETTICKETPARTS })).subscribe((Result: any) => {
      if (Result != undefined && Result != "" && Result != null) {
        this.partSource = [];
        this.partSource.push({ label: "", value: 0 });
        for (let c of Result) {
          this.partSource.push({ label: c.ticketPartSourceCode, value: c.ticketPartSourceId });
        }
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
  }
  public FavouriteRowClick(i) {
    this.TotalAmount = 0;
    let Data: buildingUsedRepair;
    var SelectedData = this.selectedfavoriteParts;
    if (this.formFields.partsUsedDuringRepair == null) {
      this.formFields.partsUsedDuringRepair = [];
    }

    Data = {
      quantity: 1,
      partId: SelectedData.partId,
      partNumber: SelectedData.partNumber,
      manufacturerName: SelectedData.manufacturerName,
      partDescription: SelectedData.partDescription,
      originalUnitCost: SelectedData.unitCost,
      unitCost: SelectedData.unitCost,
      dateOfInstall: this.formFields.srCompletedDate, //new Date().toLocaleDateString(),//Added By Harikesh on 23-july-2020
      isPartUnderWarranty: SelectedData.isPartUnderWarranty,
      rgaNumber: SelectedData.rgaNumber,
      showRgaOptions: SelectedData.showRgaOptions,
      ticketPartSourceId: null,
      isReplacingWarrantyPartFlag: SelectedData.isReplacingWarrantyPartFlag,
      isRGAQualifiedFlag: SelectedData.isRGAQualifiedFlag,
      zeroCost: false
    }
    // this.selectedRowData.push(Data);
    //Start:Commented By Harikesh on 16-Oct-2020 for Defect#12407
    // this.formFields.partsUsedDuringRepair.push(Data);
    // this.formFields.partsUsedDuringRepair= this.formFields.partsUsedDuringRepair.filter(
    //   (thing, i, arr) => arr.findIndex(t => t.partId=== thing.partId) === i
    // );
    //End:Commented By Harikesh on 16-Oct-2020 for Defect#12407

    //Start:Added By Harikesh on 16-Oct-2020 for Defect#12407
    let pCount:number=0;
    if(this.formFields.partsUsedDuringRepair)
    {
      pCount=this.formFields.partsUsedDuringRepair.filter(x=>x.partId==SelectedData.partId).length; 
    }
    if(pCount==0)
    {
      this.formFields.partsUsedDuringRepair.push(Data);
    }
    //End:Added By Harikesh on 16-Oct-2020 for Defect#12407
    this.gettotalAmount();

  }
  public addQuantity(Rowid) {
    this.formFields.partsUsedDuringRepair[Rowid].quantity = this.formFields.partsUsedDuringRepair[Rowid].quantity + 1;
    //this.TotalAmount=this.formFields.partsUsedDuringRepair[Rowid].unitCost * this.formFields.partsUsedDuringRepair[Rowid].quantity;
    //this.formFields.partTotalAmount=this.currencyPipe.transform(this.TotalAmount, '$');
    //this.formFields.partsUsedDuringRepair[Rowid].unitCost = this.formFields.partsUsedDuringRepair[Rowid].unitCost + this.formFields.partsUsedDuringRepair[Rowid].unitCost;
    this.gettotalAmount();
  }
  public RemoveQuantity(Rowid) {
    let PartID=this.formFields.partsUsedDuringRepair[Rowid].partId
    if (this.formFields.partsUsedDuringRepair[Rowid].quantity == 1) {
      this.formFields.partsUsedDuringRepair = this.formFields.partsUsedDuringRepair.filter(x => x.partId != this.formFields.partsUsedDuringRepair[Rowid].partId);
    }
    else {
      this.formFields.partsUsedDuringRepair[Rowid].quantity = this.formFields.partsUsedDuringRepair[Rowid].quantity - 1;
      // var val = this.formFields.partsUsedDuringRepair[Rowid].unitCost / 2
      // this.formFields.partsUsedDuringRepair[Rowid].unitCost = val;
      this.TotalAmount=this.formFields.partsUsedDuringRepair[Rowid].unitCost * this.formFields.partsUsedDuringRepair[Rowid].quantity;
      this.formFields.partTotalAmount=this.currencyPipe.transform(this.TotalAmount, '$');
    }
    if(this.selectedfavoriteParts !=undefined && this.selectedfavoriteParts!=null)
    {
      if(this.selectedfavoriteParts.partId==PartID)
      {
        this.selectedfavoriteParts=[];
      }
    }
    if(this.selectedpartList !=undefined && this.selectedpartList!=null)
    {
    if(this.selectedpartList.partId==PartID)
    {
      this.selectedpartList=[];
    }
  }
  if(this.formFields.partsUsedDuringRepair.length==0)
  {
    this.formFields.partsUsedDuringRepair=null;
    this.formFields.partTotalAmount= this.currencyPipe.transform(0, '$');
  }
   else{
     this.gettotalAmount();
   }
    
  }
  public partUsedRowClick(rowId) {
    if (this.formFields.partsUsedDuringRepair == null) {
      this.formFields.partsUsedDuringRepair = [];
    }

    let Data: buildingUsedRepair;
    var SelectedData = this.selectedpartList;
    Data = {
      quantity: 1,
      partId: SelectedData.partId,
      partNumber: SelectedData.partNumber,
      manufacturerName: SelectedData.manufacturerName,
      partDescription: SelectedData.partDescription,
      originalUnitCost: SelectedData.unitCost,
      unitCost: SelectedData.unitCost,
      dateOfInstall: this.formFields.srCompletedDate,//new Date().toLocaleDateString(),
      isPartUnderWarranty: SelectedData.isPartUnderWarranty,
      rgaNumber: SelectedData.rgaNumber,
      showRgaOptions: SelectedData.showRgaOptions,
      ticketPartSourceId: null,
      isReplacingWarrantyPartFlag: SelectedData.isReplacingWarrantyPartFlag,
      isRGAQualifiedFlag: SelectedData.isRGAQualifiedFlag,
      zeroCost: false
    }
    //Start:Commented By Harikesh on 16-Oct-2020 for Defect#12407
    // this.formFields.partsUsedDuringRepair.push(Data);
    // this.formFields.partsUsedDuringRepair= this.formFields.partsUsedDuringRepair.filter(
    //   (thing, i, arr) => arr.findIndex(t => t.partNumber=== thing.partNumber) === i
    // );
    //End:Commented By Harikesh on 16-Oct-2020 for Defect#12407

    //Start:Added By Harikesh on 16-Oct-2020 for Defect#12407
    let pCount:number=0;
    if(this.formFields.partsUsedDuringRepair)
    {
      pCount=this.formFields.partsUsedDuringRepair.filter(x=>x.partId==SelectedData.partId).length; 
    }
    if(pCount==0)
    {
      this.formFields.partsUsedDuringRepair.push(Data);
    }
    //End:Added By Harikesh on 16-Oct-2020 for Defect#12407
    this.gettotalAmount();
  }
  public buildFavoritePartButton(partId) {
    let val = 0;
    val = this.checkFavoriteParts(partId);
    return val;
  }
  public checkFavoriteParts(partId) {
    if (this.favoritePartsArray !=null) {
      var isFavoritePart=[];
       isFavoritePart = this.favoritePartsArrayTemp.filter(x => x.partId == partId);
      if (isFavoritePart.length>0) {
        return 1;
      }
      else{
        return 0
      }

    }

  }
  public async SaveFavoriteParts() 
  {
    var favoriteListId =this.SelectedFavouriteID!=null? this.SelectedFavouriteID.value:null;
    if(favoriteListId == null ||favoriteListId == undefined  ) 
    {
      this._messageService.showAlertMessage("Please choose a list")
      return false;
    }
    if (this.favoriteListName=="" && favoriteListId ==0)
    {
      this._messageService.showAlertMessage("Please enter a name for the list")
      return false;
    }
    if(favoriteListId==0)
    {
      //*************** Add new item to favorite List************** */
      var nameExists= await this.checkFavoriteListName(this.favoriteListName  , this.favoriteListTypeId, "null");
      if(nameExists)
      {
        
        this._messageService.showAlertMessage("A list with that name already exists");
        return false;
      }
      var ADDFAVORITELIST = {
        favoriteListTypeId : this.favoriteListTypeId,
        userId :this.userId,
        favoriteListName:this.favoriteListName     
      };
      var GETFAVORITELIST = {
        favoriteListTypeId :this.favoriteListTypeId,
        userId :   this.userId,
        favoriteListName: this.favoriteListName
      }; 
      this._favoriteService.addFavoriteList(JSON.stringify({GETFAVORITELIST, ADDFAVORITELIST}) )
      .subscribe((listsResponse: any) =>
       {
         //*************** Map  Parts to favorite List************** */
          favoriteListId=listsResponse.records[0].favoriteListId
          this.addFavouritelistparam.favoriteListId = favoriteListId
          this.addFavouritelistparam.favoritenmae = this.favoriteListName
          var params =
          {
            "ADDFAVORITELISTPART":
            {
            favoriteListId: this.addFavouritelistparam.favoriteListId,
            partId: this.addFavouritelistparam.partId

            }
          }
          this._favoriteService.addFavoriteListPart(JSON.stringify(params)).subscribe((Result: any) => {
          if (Result.addRecord.length > 0) 
          {
            this.IsSaved = true;
            this.getFavoriteListParts();
            this.favoriteListName="";
            this.SelectedFavouriteID=null;
          }
            this.IsSaved = true;
          },
          (respose: Response) => 
          {
            this.IsSaved = false;
          }
          );

        },
        (respose: Response) => {
          this.IsSaved = false;
        }
      );

    }
    else
    {
      this.addFavouritelistparam.favoriteListId = this.SelectedFavouriteID.value
      this.addFavouritelistparam.favoritenmae = this.SelectedFavouriteID.label
      var params =
      {
        "ADDFAVORITELISTPART":
        {
          favoriteListId: this.addFavouritelistparam.favoriteListId,
          partId: this.addFavouritelistparam.partId

        }
      }
      this._favoriteService.addFavoriteListPart(JSON.stringify(params)).subscribe((Result: any) => {
        if (Result.addRecord.length > 0) {
          this.IsSaved = true;
          this.getFavoriteListParts();
        }
        this.IsSaved = true;
      },
        (respose: Response) => {
          // handle error here
        }
      );
    }
  }
  public AddTofavourite(rowId) {
    this.addFavouritelistparam.description = this.formFields.partsUsedDuringRepair[rowId].partDescription
    this.addFavouritelistparam.partId = this.formFields.partsUsedDuringRepair[rowId].partId
    this.addFavouritelistparam.partNumber=this.formFields.partsUsedDuringRepair[rowId].partNumber
    this.ShowaddfavouriteDailoge = true;
    this.IsSaved = false;
    this.SelectedFavouriteID=null
  }
  public FavoriteListIdchange(value) {
    if (value == 0) {
      this.favoritePartsArray = this.favoritePartsArrayTemp
    }
    else {
      var data = this.favoritePartsArrayTemp.filter(x => x.favoriteListId == value);
      this.favoritePartsArray = data;
    }

  }
  public closeFavDuringRepair() {
    this.showFavouriteListDailog = false;
  }
  public gettotalAmount() {

   this.checkRGANumber()

    this.TotalAmount = 0;
    this.formFields.partsUsedDuringRepair.forEach(obj => {
      this.TotalAmount +=obj.quantity*obj.unitCost
      });
    this.formFields.partTotalAmount= this.currencyPipe.transform(this.TotalAmount, '$');
    
    this.formFields.partsUsedDuringRepair=this.formFields.partsUsedDuringRepair.sort((a, b) => (parseInt(a.partNumber) > parseInt(b.partNumber) ? 1 : -1));
  }
  public validateAdHocPart(Data: any) {
    var errors = new Array();
    var i = 0;
    var unique = null;
    var copyData = false;
    var ret = {
      isValid: false,
      partUnique: true,
      manufacturerId: Data.manufacturerId,
      manufacturerName: null,
      partNumber: Data.partNumber,
      partDescription: Data.partDescription,
      unitPrice: Data.unitPrice,
      partId: null,
      Mesg: [] = errors,
    }


    var ISPARTUNIQUE = {
      "ISPARTUNIQUE":
      {
        "partNumber": Data.partNumber,
      }
    }
    if (Data.partNumber == 0 || Data.partNumber==null || Data.partNumber==undefined) {
      errors.push('Please enter a part number.');
    } else {

      this._partsService.isPartUnique(JSON.stringify({ ISPARTUNIQUE })).subscribe((Result: any) => {
        if (Result != null) {
          var dupeMessage = '';
          dupeMessage += 'Another part was found with this part number \n\n';
          dupeMessage += 'Manufacturer: ' + unique.partdata.data.manufacturername[0] + '\n\n';
          dupeMessage += 'Part Number: ' + unique.partdata.data.partnumber[0].toString() + '\n\n';
          dupeMessage += 'Part Description: ' + unique.partdata.data.partdescription[0] + '\n\n';
          dupeMessage += 'Unit Price: ' + unique.partdata.data.unitprice[0] + '\n\n\n';
          dupeMessage += 'Do you want to use this part?';

          // conform meessage
          this.isunique=true
          this._confirmationService.confirm({
            message: 'Are you sure that you want to perform this action?',
            accept: () => {

              ret.partUnique = false;
              ret.partId = Data.partId;
              ret.manufacturerId = Data.manufacturerId;
              ret.manufacturerName = Data.manufacturerName;
              ret.partDescription = Data.partDescription;
              ret.partNumber = Data.partNumber;
              ret.unitPrice = Data.unitPrice;
              Mesg: [] = errors;
              this.isunique=false;

            },
            reject: () => {

              this.isunique=false
            }
          });

        }
      },
        (respose: Response) => {
          // handle error here
        }
      );

    }
    if (Data.manufacturerId == 0 || Data.manufacturerId == undefined || Data.manufacturerId == null) {
      errors.push('Please choose a manufacturer.');
    }
    if (Data.partDescription.length == "" || Data.partDescription.length ==null) {
      errors.push('Please enter a description.');
    }
    if (Data.unitPrice == null || Data.unitPrice == undefined || Data.unitPrice == 0) {
      errors.push('Please enter a unit price.');
    }

    if (errors.length == 0) {
      ret.isValid = true;
    }

    
    return ret;
  }
  public isRGAShow=false
  public checkRGANumber()
  {
    try
    {
      if(this.formFields.partsUsedDuringRepair!=null &&this.formFields.partsUsedDuringRepair.length>0 )
      {
        if(this.formFields.partsUsedDuringRepair.filter(x=>x.originalUnitCost>=25).length>0)
        {
          this.isRGAShow=true
        }
        else{
          this.isRGAShow=false;
        }
      }
    }
    catch
    {
      
    }
  }

  public async checkFavoriteListName (favoriteListName: string,favoriteListTypeId: number,favoriteListId:string)
    {
     
      let nameExists:boolean= false;
      var GETFAVORITELIST:any = { favoriteListName:favoriteListName, favoriteListTypeId:favoriteListTypeId,
        favoriteListId:favoriteListId,check:1
      ,userId:this.userId };
        
      await this._favoriteService.getFavoriteListSync(JSON.stringify({GETFAVORITELIST}) )
      .then((listsResponse: any) => 
      {
       let favoriteData = listsResponse;
       if(favoriteData.records.length > 0)
       {
        nameExists = true;
       }
      }
      );
      return nameExists;
    }

    public getFavoriteList()
    {
      this.addToFavoriteDropdown=[];
      let getFavListParam=
      {
        "GETFAVORITELIST": 
        {
            favoriteListTypeId: this.favoriteListTypeId,
            userId: this.userId,
        }
      }
     
      this._favoriteService.getFavoriteList(JSON.stringify(getFavListParam)).subscribe(data=>
        {
          if (data!=null && data.records.length > 0)
          {
            this.addToFavoriteDropdown=data.records.map(data => ({ 
              label: data.favoriteListName , 
              value: data.favoriteListId,
            }));
            this.addToFavoriteDropdown.splice(0, 0, { label: "New..", value: 0 })
          }
          else
          {
            this.addToFavoriteDropdown=[{label:'New...',value:0}]
          }
         
        })
    }
  public setZeroCast(partId:Number)
  {
   
    let objPartUsed:buildingUsedRepair=this.formFields.partsUsedDuringRepair.find(x=>x.partId==partId);
    if(objPartUsed!=null)
    {
      if(objPartUsed.zeroCost==true)
      {
        objPartUsed.unitCost=0
      }
      else if(objPartUsed.zeroCost==false)
      {
        objPartUsed.unitCost=objPartUsed.originalUnitCost
      }
      this.gettotalAmount();
    }
  }
  public OrderPartUsedTable(objPartUsed:buildingUsedRepair[])
  {
    if(objPartUsed!=null && objPartUsed.length>0)
    {
      return objPartUsed.sort((a, b) => b.partId- a.partId);
    }
    else
    {
      return objPartUsed;
    }
  }
}
